import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "sm:hidden" }
const _hoisted_3 = { class: "hidden sm:flex flex-wrap items-center -m-3" }
const _hoisted_4 = ["textContent", "onClick"]

import {
  computed, ref, toRefs, watch,
} from 'vue';
import { unwrapFunction } from '@/utils';

interface GenericTab {
  key: string,
  label: string,
  when?: boolean | (() => boolean),
}


export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: null,
    active: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as {
  tabs: GenericTab[],
  active?: string,
}




const { tabs, active } = toRefs(props);

const filteredTabs = computed(() => tabs.value.filter(
  (tab) => tab.when === undefined || unwrapFunction(tab.when),
));

const activeTabKey = ref<string>('');
const select = (tabKey: string) => {
  activeTabKey.value = tabKey;
  emit('update', tabKey);
};
const isActive = (tabKey: string) => tabKey === activeTabKey.value;
const reset = () => { activeTabKey.value = active?.value ?? filteredTabs.value[0]?.key; };
reset();
watch(tabs, reset);

const scope = computed(() => ({
  activeTabKey: activeTabKey.value,
  activeTab: tabs.value.find((tab) => tab.key === activeTabKey.value),
  isActive,
  select,
  reset,
}));

return (_ctx: any,_cache: any) => {
  const _component_base_select = _resolveComponent("base-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_base_select, {
          modelValue: activeTabKey.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTabKey).value = $event)),
          options: _unref(filteredTabs),
          "as-value": "key"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTabs), (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.key,
            class: "m-3"
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["px-3 py-2 font-medium text-sm rounded-md", isActive(tab.key) ? 'bg-gray-700 text-white' : 'text-gray-500 hover:text-gray-700']),
              textContent: _toDisplayString(tab.label),
              onClick: ($event: any) => (select(tab.key))
            }, null, 10, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(scope))))
  ]))
}
}

})